import { motion } from "framer-motion";
import { Facebook, Instagram, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export const Contact = () => {
  return (
    <section
      id="kontakt"
      data-testid="contact-section"
      className="relative py-28 md:py-40 px-6 lg:px-12 border-t border-[#D4AF37]/10"
    >
      <div
        className="ambient-glow"
        style={{
          width: 500,
          height: 500,
          background: "rgba(212, 175, 55, 0.14)",
          bottom: "0%",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      />

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="gold-divider"
          data-testid="contact-eyebrow"
        >
          Kontakt
        </motion.span>

        <motion.h2
          data-testid="contact-heading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          viewport={{ once: true }}
          className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#E5E5E5] mt-8"
        >
          Lassen Sie uns <span className="italic gold-text">Licht fangen.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.4, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-8 text-[#E5E5E5]/70 font-sans font-light text-base md:text-lg max-w-xl mx-auto leading-relaxed"
          data-testid="contact-text"
        >
          Für Anfragen schreiben Sie mir gerne. Ich freue mich über jedes
          Funkeln in meinem Postfach.
        </motion.p>

        {/* Socials */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.5, ease: "easeOut" }}
          viewport={{ once: true }}
          className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6"
          data-testid="contact-socials"
        >
          <a
            href="https://www.facebook.com/profile.php?id=100063694391743"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-facebook-link"
            className="btn-gold group inline-flex items-center gap-3 px-8 py-4 font-sans font-light tracking-widest text-xs uppercase"
          >
            <Facebook size={18} strokeWidth={1.4} />
            <span>Facebook</span>
          </a>

          <a
            href="https://www.instagram.com/die_lichtmalerin"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-instagram-link"
            className="btn-gold group inline-flex items-center gap-3 px-8 py-4 font-sans font-light tracking-widest text-xs uppercase"
          >
            <Instagram size={18} strokeWidth={1.4} />
            <span>Instagram</span>
          </a>

          <a
            href="mailto:die_lichtmalerin@web.de"
            data-testid="social-email-link"
            className="btn-gold group inline-flex items-center gap-3 px-8 py-4 font-sans font-light tracking-widest text-xs uppercase"
          >
            <Mail size={18} strokeWidth={1.4} />
            <span>E-Mail</span>
          </a>
        </motion.div>
      </div>

      {/* Footer */}
      <footer
        data-testid="site-footer"
        className="relative z-10 mt-32 pt-10 border-t border-[#D4AF37]/10 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-sans font-light text-[#A1A1AA] uppercase tracking-[0.35em]"
      >
        <p data-testid="footer-copyright">
          © {new Date().getFullYear()} · Nicole Meinhold
        </p>
        <p className="font-serif italic normal-case tracking-normal text-[#D4AF37]/70 text-sm">
          Aus der Dunkelheit — ein Funke.
        </p>
        <div className="flex items-center gap-6">
          <Link
            to="/impressum"
            data-testid="footer-impressum-link"
            className="hover:text-[#D4AF37] transition-colors"
          >
            Impressum
          </Link>
          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="text-[#A1A1AA]/40 hover:text-[#D4AF37] transition-colors text-[9px] tracking-[0.4em]"
            title="Nur für Nicole"
          >
            ·
          </Link>
        </div>
      </footer>
    </section>
  );
};
